import CTNButton from '@ctn/ui/components/ctn-button';
import CTNInput from '@ctn/ui/components/ctn-input';
import { useEffect, useState, type ReactElement } from 'react';
import { useForm } from 'react-hook-form';
import { deleteInscription, getInscription } from '../../services/datosGenerales.service';
import { useParams } from 'react-router-dom';
import Notificacion from '../../components/Notificacion';
import Loader from '../../components/Loader';

const DetallesInscripcion = (): ReactElement => {
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const [showDatosInscripcion, setShowDatosInscripcion] = useState<boolean>(true);
	const [code, setCode] = useState<number | undefined>(undefined);
	const { inscripcionId } = useParams();
	const { control, reset } = useForm({
		defaultValues: {
			email: '',
			name: '',
			surnames: '',
			entity: '',
			assist: '',
		},
	});
	const contentSuccess = {
		titulo: 'Baja realizada correctamente',
		detalle: 'En breve recibirá confirmación de su baja',
	};

	const contentError = {
		titulo: 'No se ha podido realizar la baja',
		detalle: 'Por favor, pulse el siguiente botón y vuelva a intentarlo',
	};
	const handleDeleteInscription = async () => {
		try {
			const response = await deleteInscription(inscripcionId as string);
			setShowDatosInscripcion(false);
			setCode(response.code);
		} catch (error) {
			console.error('Error al eliminar la inscripción:', error);
			setCode(500);
		}
	};

	const getDetailInscripcion = async (uuid: string | number) => {
		setIsLoading(true);
		try {
			const { data, code } = await getInscription(uuid);
			if (code === 200) {
				reset(data.datos);
				setCode(code);
			}
		} catch (error) {
			setCode(500);
			console.log(error);
		} finally {
			setIsLoading(false);
		}
	};

	useEffect(() => {
		if (inscripcionId) {
			getDetailInscripcion(inscripcionId);
		}
	}, [inscripcionId]);

	const renderDetallesInscripcion = () => (
		<>
			<div role="group" aria-labelledby="sign-head">
				<div className="p-home__header">
					<p id="sign-head">Datos de la inscripción</p>
				</div>
				<div className="[ o-grid ] [ u-mt-24 ]">
					<div className="o-grid__row">
						<div className="o-grid__col-3@desktop">
							<CTNInput displayOnly control={control} name="name" label="NOMBRE" type="text" />
						</div>
						<div className="o-grid__col-3@desktop">
							<CTNInput displayOnly control={control} name="surnames" label="APELLIDOS" type="text" />
						</div>
						<div className="o-grid__col-6@desktop">
							<CTNInput displayOnly control={control} name="entity" label="ENTIDAD" type="text" />
						</div>
					</div>
					<div className="o-grid__row">
						<div className="o-grid__col-6@desktop">
							<CTNInput displayOnly control={control} name="email" label="EMAIL" type="text" />
						</div>
						<div className="o-grid__col-6@desktop">
							<CTNInput displayOnly control={control} name="assist" label="ASISTENCIA" type="text" />
						</div>
					</div>
				</div>
			</div>
			<div className="p-home">
				<p className="p-home__title">Si desea confirmar la baja, pulse el siguiente botón.</p>
			</div>
			<div>
				<CTNButton
					key="confirmar baja"
					className="c-jt-button c-jt-button--danger"
					label="CONFIRMAR BAJA"
					type="submit"
					size="size-40"
					onClick={handleDeleteInscription}
				/>
			</div>
		</>
	);

	const renderNotificacion = () => (
		<Notificacion code={code ?? 0} contentSuccess={contentSuccess} contentError={contentError} />
	);

	if (isLoading) {
		return <Loader />;
	}
	return (
		<div className="[ o-layout__body ] [ p-home ]">
			{showDatosInscripcion ? renderDetallesInscripcion() : renderNotificacion()}
		</div>
	);
};

export default DetallesInscripcion;
